import * as React from 'react';

import * as styles from './styles.css';

interface IBlockHeaderProps {
  children: React.ReactNode;
}

export function BlockHeader({ children }: IBlockHeaderProps) {
  return <h3 className={styles['header']}>{children}</h3>;
}
